import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6 font-handwritten">Privacy Policy</h1>
      <div className="space-y-6 text-gray-700 dark:text-gray-300">
        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Introduction</h3>
          <p className="mb-2">Your privacy is important to us. This Privacy Policy explains how Ry&apos;s Circus collects, uses, and discloses your personal information when you use our website and services.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Information We Collect</h3>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li><strong>Personal Information:</strong> Name, email address, postal address, phone number.</li>
            <li><strong>Payment Information:</strong> Billing address and payment details (processed securely via Stripe; we do not store full payment credentials on our servers).</li>
            <li><strong>Order Data:</strong> Products purchased, order history, shipping information.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, device information, operating system, and usage data collected via cookies and analytics.</li>
          </ul>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">How We Use Your Information</h3>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>To process and fulfill your orders.</li>
            <li>To communicate order status and send transactional emails.</li>
            <li>To provide customer support and respond to inquiries.</li>
            <li>To personalize content and improve user experience.</li>
            <li>To analyze site usage and performance with analytics tools.</li>
            <li>To prevent fraud and enhance security.</li>
          </ul>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Sharing Your Information</h3>
          <p className="mb-2">We may share your information with:</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li><strong>Service Providers:</strong> Stripe (payment processor), Printful (order fulfillment), shipping carriers, and other vendors that help operate our site.</li>
            <li><strong>Compliance:</strong> Authorities when required by law or to protect our rights.</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of assets.</li>
          </ul>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Data Retention</h3>
          <p className="mb-2">We retain personal information as needed to provide services, comply with legal obligations, resolve disputes, and enforce agreements.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Security</h3>
          <p className="mb-2">We implement appropriate security measures to protect your information. However, no transmission over the internet is completely secure.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Your Rights</h3>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>You may access, update, or delete your personal information by logging into your account or contacting us.</li>
            <li>You may object to or restrict our processing of your data under certain circumstances.</li>
            <li>You may withdraw consent at any time where applicable.</li>
          </ul>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Age Restrictions</h3>
          <p className="mb-2">Our site requires visitors to be at least 18 years old. We do not intentionally collect information from individuals under 13. If you believe we have collected data from a child under 13, please contact us to delete the information.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Cookies and Tracking</h3>
          <p className="mb-2">We use cookies and similar technologies to enhance your experience, analyze traffic, and deliver personalized content. You may disable cookies through your browser settings.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Third-Party Links</h3>
          <p className="mb-2">Our site may contain links to external websites. We are not responsible for their privacy practices. Please review their policies before providing personal data.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Changes to This Policy</h3>
          <p className="mb-2">We may update this Privacy Policy periodically. The date at the bottom will reflect the latest revision.</p>
        </section>

        <section>
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">Contact Us</h3>
          <p className="mb-2">For questions, please contact <a href="mailto:privacy@ryscircus.com" className="text-blue-600 dark:text-blue-400 hover:underline">privacy@ryscircus.com</a>.</p>
        </section>

        <p className="mt-8 text-sm text-gray-500 dark:text-gray-400">Last Updated: April 1, 2025</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;